import React from "react";

import { Slice } from 'modules/insights';

import './sliceCustomTooltip.sass';

/**
 * Custom slice tooltip component for Nivo line charts.
 * Displays data points with percentage values (if applicable) alongside y values.
 * Shows all series data at a specific x-axis position when hovering.
 */
export const SliceTooltipComponent = ({ slice }: { slice: Slice }) => {
    if (!slice?.points?.length) return null;

    const sortedPoints = [...slice.points].sort((a, b) => +(b.data.viewRate ?? 0) - +(a.data.viewRate ?? 0));

    return (
        <div className="slice-tooltip">
            <div className="header">
                {slice.points[0].data.x}
            </div>
            {sortedPoints.map((point, index) => (
                <div key={point.id || index} className="point">
                    <div
                        className="color-indicator"
                        style={{ backgroundColor: point.serieColor }}
                    />
                    <span className="label">
                        {point.serieId}: <strong>{point.data.viewRate ? `${point.data.y} (${point.data.viewRate}%)` : point.data.y}</strong>
                    </span>
                </div>
            ))}
        </div>
    );
};
